export enum TypeRondeCodeEnum {
  SUISSE = 'SUISSE',
  ROBIN = 'ROBIN',
  ROBIN2 = 'ROBIN2',
}
